<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="copy" id="copy">Copyright © 2003 by Iain Levison</p>
<p class="ser1" style="margin-top: 2%;">All rights reserved.</p>
<p class="ser">Published by</p>
<p class="ser">Soho Press Inc.</p>
<p class="ser">853 Broadway</p>
<p class="ser1">New York, NY 10003</p>
<p class="ser">Library of Congress Cataloging-in-Publication Data Levison, Iain.</p>
<p class="ser">Since the layoffs : a novel / Iain Levison. p. cm.</p>
<p class="ser">ISBN 1-56947-335-8 (alk. paper)<br/>eISBN 978-1-56947-921-6</p>
<p class="ser">1. Young men—Fiction. 2. Unemployed—Fiction.</p>
<p class="ser">3. Criminals—Fiction. I. Title.</p>
<p class="ser">PS3612.E837S56 2003</p>
<p class="ser1">813’.6—dc21    2002044654</p>
<p class="ser">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c5.vue?786a576c